import { render, staticRenderFns } from "./DoctorInvitationModal.vue?vue&type=template&id=dea7f5f2&"
import script from "./DoctorInvitationModal.vue?vue&type=script&lang=ts&"
export * from "./DoctorInvitationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports